import {styled} from "@mui/material/styles";

export const StyledText = styled('text', {
        shouldForwardProp: (prop) => prop !== 'variant',
    })(({theme}) => ({
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fill: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    variant: 'primary',
                },
                style: {
                    fontSize: theme.typography.h5.fontSize,
                },
            },
            {
                props: ({variant}) => variant !== 'primary',
                style: {
                    fontSize: theme.typography.body2.fontSize,
                },
            },
            {
                props: {
                    variant: 'primary',
                },
                style: {
                    fontWeight: theme.typography.h5.fontWeight,
                },
            },
            {
                props: ({variant}) => variant !== 'primary',
                style: {
                    fontWeight: theme.typography.body2.fontWeight,
                },
            },
        ],
    }));

    export const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    };

    // export const  base64toBlob = (base64Data, contentType) => {
    //     contentType = contentType || '';
    //     let sliceSize = 1024;
    //     let byteCharacters = asciiToBinary(base64Data);
    //     //let byteCharacters = base64Data;
    //     alert(14);
    //     let bytesLength = byteCharacters.length;
    //     let slicesCount = Math.ceil(bytesLength / sliceSize);
    //     let byteArrays = new Array(slicesCount);
    //     for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    //         let begin = sliceIndex * sliceSize;
    //         let end = Math.min(begin + sliceSize, bytesLength);
    //
    //         let bytes = new Array(end - begin);
    //         for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
    //             bytes[i] = byteCharacters[offset].charCodeAt(0);
    //         }
    //         byteArrays[sliceIndex] = new Uint8Array(bytes);
    //     }
    //     return new Blob(byteArrays, { type: contentType });
    // };
    //
    // export const asciiToBinary = (input) => {
    //     let output = '';
    //
    //     for (let char of input) {
    //
    //         let asciiValue = char.charCodeAt(0); // Get ASCII value
    //
    //         let binaryValue = asciiValue.toString(2); // Convert to binary
    //
    //         output += binaryValue + ' ';
    //
    //     }
    //
    //     return output;
    // };